module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-rahmen-02.0aa946a6.jpeg";